import { FC, SVGAttributes } from 'react';

type DangerSvgProps = SVGAttributes<SVGElement>;

export const DangerSvg: FC<DangerSvgProps> = (props) => {
    return (
        <svg
            width="21"
            height="22"
            viewBox="0 0 21 22"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            {...props}>
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M8.045 0.758176L5.97226 7.7017L5.97308 7.70194L7.83194 8.25684C8.56957 8.47703 8.89718 9.32255 8.48865 9.95174L2.54603 19.1044C2.18951 19.6535 1.31454 19.2571 1.50141 18.6311L3.57414 11.6876L3.57332 11.6873L1.71446 11.1324C0.97683 10.9122 0.649225 10.0667 1.05775 9.43752L7.00037 0.28483C7.35689 -0.264271 8.23186 0.1322 8.045 0.758176ZM20.1073 11.8274L14.9863 15.3269L14.9873 15.3279L16.2328 16.743C16.7271 17.3046 16.5772 18.0562 15.9324 18.2498L6.55303 21.0654C5.99033 21.2343 5.47088 20.4774 5.93286 20.1617L11.0539 16.6622L11.0529 16.6612L9.80738 15.2461C9.31312 14.6845 9.46297 13.9329 10.1077 13.7393L19.4871 10.9237C20.0498 10.7548 20.5693 11.5117 20.1073 11.8274Z"
                fill="#DB5311"
            />
        </svg>
    );
};
